export class VerificadorSenha {
  constructor(senha, registro, dataNascimento, options) {
    this.senha = senha
    this.registro = registro
    this.dataNascimento = dataNascimento
    this.options = options

    this.senhaValida = false
    this.politicasVisiveisValida = false

    this.politicas = this.createRules(this.options, this.registro, this.dataNascimento)
  }

  createRules(options, registro, dataNascimento) {
    return [
      {
        mensagem: options.mensagens.tamanhoMinimo,
        padrao: /\S{8,}/,
        valida: false,
        visivel: true
      },
      {
        mensagem: options.mensagens.contem_numero,
        padrao: /\d/,
        valida: false,
        visivel: true
      },
      {
        mensagem: options.mensagens.contem_minuscula,
        padrao: /[a-z]/,
        valida: false,
        visivel: true
      },
      {
        mensagem: options.mensagens.contem_maiuscula,
        padrao: /[A-Z]/,
        valida: false,
        visivel: true
      },
      // {
      //   mensagem: options.mensagens.nao_contem_sequencias,
      //   padrao: /^(?!.*\d{2,}(?=\d)(?<=\d)\d).*$/,
      //   valida: false,
      //   visivel: true
      // },
      {
        mensagem: options.mensagens.nao_contem_prontuario,
        padrao: new RegExp(`^((?!${this.registro}).)*$`, 'i'),
        valida: false,
        visivel: false
      },
      {
        mensagem: options.mensagens.nao_contem_data_nascimento,
        padrao: new RegExp(`^((?!${dataNascimento}).)*$`),
        valida: false,
        visivel: false
      }
    ]
  }

  validar(senha) {
    this.politicas = this.createRules(this.options, this.registro, this.dataNascimento)

    this.politicas.forEach((politica) => {
      politica.valida = politica.padrao.test(senha)
    })

    this.senhaValida = this.politicas.every((politica) => {
      return politica.valida === true
    })

    this.politicasVisiveisValida = this.politicas.filter(m => m.visivel).every((politica) => {
      return politica.valida === true
    })
  }

  mensagensErro() {
    return this.politicas
      .filter((politica) => !politica.valida)
      .map((politica) => `- ${politica.mensagem}`)
  }
}
